// Feature: WebRTC call quality (PLAN §5.7). Registers the Calls list and detail
// routes plus the main nav entry; see features/registry.ts.
import { createRoute } from "@tanstack/react-router";
import { registerFeature } from "../registry";
import { CallDetailPage } from "./CallDetailPage";
import { CallGroupDetailPage } from "./CallGroupsPage";
import { CallsPage } from "./CallsPage";

const passSearch = (s: Record<string, unknown>) => s;

registerFeature({
  routes: (appRoute) => [
    createRoute({ getParentRoute: () => appRoute, path: "/calls", component: CallsPage, validateSearch: passSearch }),
    createRoute({ getParentRoute: () => appRoute, path: "/calls/groups/$groupId", component: CallGroupDetailPage, validateSearch: passSearch }),
    createRoute({ getParentRoute: () => appRoute, path: "/calls/$callId", component: CallDetailPage, validateSearch: passSearch }),
  ],
  nav: [{ label: "Calls", to: "/calls", section: "main", order: 45, feature: "webrtc_groups" }],
});

export { callsApi, callKeys } from "./api";
export type { CallDetail, CallsOverview, CallsQuery, CallSeriesPoint } from "./api";
export { QualityMeter, PathBadge, CallStateBadge } from "./components";
